import { useNavigate } from 'react-router-dom'
import Card from '../../public/components/Card'
import clsx from 'clsx'
import EditableListPage from '../components/EditableListPage'
import { Button } from '../../shared/components/Button'
import { FaGripLines, FaPen } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'

const ProjectsAdmin = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const renderCard = item => (
        <Card
            key={item.id}
            imageSrc={item.image_preview || item.header_image}
            buttonLabel={t('status.details')}
            onButtonClick={() => navigate(`/admin/auth/projects/${item.id}`)}
        >
            <span
                className={clsx(
                    'inline-block px-3 py-1 text-xs font-medium rounded-full',
                    item.is_active === '1'
                        ? 'text-green-800 bg-green-200'
                        : 'text-red-800 bg-red-200'
                )}
            >
                {item.is_active === '1' ? t('status.active') : t('status.inactive')}
            </span>
            <span className='inline-block px-3 py-1 ml-2 text-xs font-medium text-yellow-800 bg-yellow-200 rounded-full'>
                {item.project_category_name || item.project_category_name_en}
            </span>
            <h3>{item.title}</h3>
            <span className='text-sm text-gray-500'>{item.subtitle || item.subtitle_en}</span>
            <p>{item.urgency_message || item.urgency_message_en}</p>
        </Card>
    )

    return (
        <EditableListPage
            title={t('navigation_admin.projects.main')}
            endpoint='admin/projects'
            renderCard={renderCard}
            buttons={
                <>
                    <Button
                        variant='secondary'
                        size='medium'
                        onClick={() => navigate('/admin/auth/projects/reorder')}
                    >
                        <FaGripLines /> {t('status.reorder')}
                    </Button>
                    <Button size='medium' onClick={() => navigate('/admin/auth/projects/create')}>
                        <FaPen /> {t('status.create')}
                    </Button>
                </>
            }
        />
    )
}

export default ProjectsAdmin
